var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_1381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.332 8.32031L22.8789 15.9766C21.3066 17.2461 21.0039 19.5312 22.1953 21.1621C23.4551 22.9004 25.9062 23.2422 27.5957 21.9238L37.293 14.3848C37.9766 13.8574 38.9531 13.9746 39.4902 14.6582C40.0273 15.3418 39.9004 16.3184 39.2168 16.8555L37.1758 18.4375L54.4805 34.375H58.5625C61.1504 34.375 63.25 32.2754 63.25 29.6875V17.1875C63.25 14.5996 61.1504 12.5 58.5625 12.5H50.6816L50.3008 12.2559L43.2109 7.71484C41.7168 6.75781 39.9688 6.25 38.1914 6.25C36.0625 6.25 33.9922 6.98242 32.332 8.32031ZM34.5586 20.4688L29.5098 24.3945C26.4336 26.7969 21.9707 26.1719 19.666 23.0078C17.498 20.0293 18.0449 15.8691 20.9062 13.5547L29.0312 6.98242C27.8984 6.50391 26.6777 6.25977 25.4375 6.25977C23.6016 6.25 21.8145 6.79688 20.2812 7.8125L13.25 12.5H5.4375C2.84961 12.5 0.75 14.5996 0.75 17.1875V29.6875C0.75 32.2754 2.84961 34.375 5.4375 34.375H16.0039L24.9297 42.5195C26.8438 44.2676 29.8027 44.1309 31.5508 42.2168C32.0879 41.6211 32.4492 40.9277 32.6348 40.2051L34.2949 41.7285C36.1992 43.4766 39.168 43.3496 40.916 41.4453C41.3555 40.9668 41.6777 40.4102 41.8828 39.834C43.7773 41.1035 46.3555 40.8398 47.9473 39.1016C49.6953 37.1973 49.5684 34.2285 47.6641 32.4805L34.5586 20.4688Z",
    fill: "#062644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_1381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.5,
    height: 50,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.a2bdd8bc31b2ef74117c82f499bdc532.svg";
export { ForwardRef as ReactComponent };